import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import Link from 'next/link';

import { Divider, Flex, Link as JaimyLink, Text } from '@brand/components';

import { NAV_ITEMS } from 'constants/navigation';

import { useReduxDispatch } from 'hooks/redux/useReduxDispatch';
import { useReduxSelector } from 'hooks/redux/useReduxSelector';

import SearchBar from 'components/molecules/Searchbar';
import AccessControl from 'components/utils/AccesControl';
import ComponentIsVisible from 'components/utils/IsVisible';

import { authActions } from 'store/slices/auth';
import authSelectors from 'store/slices/auth/selectors';

import LocaleSwitcher from '../../LocaleSwitcher';

const MobileNav = () => {
  const accessToken = useReduxSelector(authSelectors.accessToken);

  const reduxDispatch = useReduxDispatch();
  const { t } = useTranslation(['navigation', 'common']);

  const handleLogout = useCallback(() => {
    reduxDispatch(authActions.logoutRequest());
  }, [reduxDispatch]);

  return (
    <Flex
      alignItems="center"
      display={['flex', null, 'none']}
      flexDirection="column"
      mt={4}
    >
      <ComponentIsVisible when={!!accessToken}>
        <SearchBar />
      </ComponentIsVisible>
      <ComponentIsVisible when={!!accessToken}>
        {NAV_ITEMS.map(item => (
          <AccessControl
            allowRoles={item.access}
            key={item.label}
            permission={item.permission}
          >
            <Flex>
              <Text
                color="white"
                my={0}
                py={2}
                textAlign="center"
                variant="preHeader"
              >
                <Link href={item.href} passHref>
                  <JaimyLink>{t(item.label)}</JaimyLink>
                </Link>
              </Text>
            </Flex>
          </AccessControl>
        ))}
      </ComponentIsVisible>
      <Divider display={['flex', null, 'none']} my={4} />
      <Text
        color="white"
        my={0}
        onClick={handleLogout}
        py={2}
        textAlign="center"
        variant="preHeader"
      >
        {t('common:generic.logout')}
      </Text>
      <LocaleSwitcher />
    </Flex>
  );
};

export default MobileNav;
